module.exports = __webpack_public_path__ + "static/media/download.850755c3.svg";